import { render, staticRenderFns } from "./PointFrame.vue?vue&type=template&id=3ff2c38c&"
import script from "./PointFrame.vue?vue&type=script&lang=js&"
export * from "./PointFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports